import { EventSubtype, EventType, INTERMEDIARY_ANALYTICS_MODEL_SOURCE, INTERMEDIARY_ANALYTICS_MODEL_VERSION, } from '@shared-utils/domain/event.entity';
import axios from 'axios';
import { InternalEventType } from './statsEvent.type';
const INTERMEDIARY_ANALYTICS_API_URL = `https://agency-card-bff.assured-muskrat-${process.env.ENVIRONMENT}.aws.aviv.eu/v1`;
const eventMapping = {
    [InternalEventType.CONTAINED]: {
        subtype: EventSubtype.INTERMEDIARY_WLAC_CONTAINED,
        type: EventType.INTERMEDIARY_CONTAINED,
    },
    [InternalEventType.REDIRECTED]: {
        subtype: EventSubtype.INTERMEDIARY_WLAC_CTA_REDIRECTTOIPP,
        type: EventType.INTERMEDIARY_REDIRECTION,
    },
    [InternalEventType.FORM_SUBMITTED]: {
        subtype: EventSubtype.LEAD_FORM_SUBMITTED,
        type: EventType.INTERMEDIARY_LEAD,
    },
    [InternalEventType.FILTERS_CLICKED]: {
        subtype: EventSubtype.INTERMEDIARY_CARD_FILTER_CONTAINED,
        type: EventType.INTERMEDIARY_CONTAINED,
    },
    [InternalEventType.VIEWED]: {
        subtype: EventSubtype.INTERMEDIARY_DETAIL_VIEWED,
        type: EventType.INTERMEDIARY_VIEWED,
    },
};
export class StatsEventService {
    apiUrl = INTERMEDIARY_ANALYTICS_API_URL;
    source = INTERMEDIARY_ANALYTICS_MODEL_SOURCE;
    version = INTERMEDIARY_ANALYTICS_MODEL_VERSION;
    channel;
    portal;
    place;
    product;
    static instance = null;
    logger;
    constructor(config, logger) {
        this.channel = config.channel;
        this.portal = config.portal;
        this.place = config.place;
        this.product = config.product;
        this.logger = logger;
    }
    debug(event) {
        if (process.env.ENVIRONMENT === 'dev') {
            global.console.log('===============================================');
            global.console.log('ENVIRONMENT', process.env.ENVIRONMENT);
            global.console.log(event);
            global.console.log('===============================================');
        }
    }
    static initInstance(config, logger) {
        StatsEventService.instance = new StatsEventService(config, logger);
    }
    static getInstance() {
        if (!StatsEventService.instance) {
            throw new Error('StatsEventService not initialized');
        }
        return StatsEventService.instance;
    }
    static resetInstance() {
        StatsEventService.instance = null;
    }
    sendEvent(eventData) {
        const completeEvent = {
            channel: this.channel,
            ['data.agencyLegacyBrandId']: eventData.legacyBrandId ?? null,
            ['data.agencyName']: eventData.name ?? null,
            ['data.agencyPostalCode']: eventData.zipCode ?? null,
            ['data.geoId']: eventData.geoId ?? null,
            ['data.lastUserSearch']: eventData.lastUserSearch ?? null,
            id: null,
            place: eventData.place ?? this.place,
            portal: this.portal,
            product: this.product,
            source: this.source,
            subtype: eventData.subtype,
            time: new Date().toISOString(),
            type: eventData.type,
            version: this.version,
        };
        this.debug(completeEvent);
        return axios
            .post(`${this.apiUrl}/event`, completeEvent)
            .catch((error) => this.logger('Error while sending stats  event:', error));
    }
}
export const initStatsEventService = (config, logger) => {
    StatsEventService.initInstance(config, logger);
};
export const dispatchStatsEvent = (event) => {
    const mapping = eventMapping[event.type];
    if (!mapping) {
        throw new Error(`Event type not implemented: ${event.type}`);
    }
    return StatsEventService.getInstance().sendEvent({
        ...event.payload,
        ...mapping,
    });
};
